<template>
    <!-- <section v-if="isShow">
        <div class="lock">
            <img  @click="goReleaseTime" @mouseover="showTips=true" @mouseout="showTips=false" :src="classNock" alt="">
        </div> 
        <transition name="slide">
            <div class="tips" v-if="showTips">
                {{tips}}
            </div>
        </transition>
    </section> -->
    <div class="side-menu-card class font-weight-bold" v-if="isShow" @click="goReleaseTime" >
        <span>{{tips}}</span>
        <div class="class-menu">
        </div>
    </div>
</template>
<script>
import { getSelfScheduleRemind } from '../api/user'
import { mapGetters } from 'vuex'
import { getSelfScheduleLimitCheck } from '@/api/releaseTime'

export default {
    data:()=>({
        isShow:false,
        tips:''
    }),
    mounted(){
        getSelfScheduleRemind().then(res=>{
            this.isShow = res.IsShow;
            this.tips = res.Tips
        })
        if(this.selfScheduleRemindMsg.isShow){
            this.isShow = true;
            this.tips = this.selfScheduleRemindMsg.tips
        }
    },
    methods:{
        goReleaseTime(){
            this.$router.push({ name: 'releaseTime' })
        }
    },
    computed:{
        ...mapGetters([
            'selfScheduleRemindMsg',
            'errorText'
        ])
    },
    watch:{
        'selfScheduleRemindMsg':function(){
            this.isShow = this.selfScheduleRemindMsg.isShow
            this.tips = this.selfScheduleRemindMsg.tips
        },
        'errorText':function(){
            if(!this.errorText){
                this.isShow = false
            }
        }
    }
}
</script>
<style scoped>


</style>